import { ArticleType } from '@nemuru-eng/js-api-client';

import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface CategorySelectorProps {
  type: ArticleType;
  textIdSuffix: string;
}

export const CategorySelector = ({ type, textIdSuffix }: CategorySelectorProps) => {
  const { getTextIdTranslation } = useTranslation();

  const articleCategories = ArticleTypeMap.toArticleCategories(type);

  return (
    <SelectFormField
      name={'item.category'}
      label={textIdSuffix}
      labelDynamicDataTexts={[getTextIdTranslation(type)?.toLocaleLowerCase()]}
      selectOptions={articleCategories.map((category) => ({
        value: category,
        display: <Text tId={`${textIdSuffix}_${category}`} />,
      }))}
      disabled={articleCategories.length <= 1}
      fieldVariant={FieldVariant.form}
    />
  );
};
